export { default } from './SpeedDialIcon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/SpeedDialIcon/index.js
// module id = 377
// module chunks = 0